import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { ImagePlaceholder } from "./ImagePlaceholder";

const arrowStyle = {
  width: 40,
  height: 40,
  borderRadius: "50%",
  border: "1px solid var(--border-default)",
  background: "rgba(255,255,255,0.92)",
  color: "var(--navy-700)",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const ImageCarousel = ({ images }) => {
  const [index, setIndex] = useState(0);
  if (!images.length) return null;
  const current = images[index];
  const prev = () => setIndex((index - 1 + images.length) % images.length);
  const next = () => setIndex((index + 1) % images.length);

  return (
    <div data-testid="popup-image-carousel">
      <div className="relative">
        <ImagePlaceholder key={current.file} file={current.file} ratio="16 / 10" label={current.caption} className="w-full" />
        {images.length > 1 && (
          <>
            <button type="button" onClick={prev} aria-label="Previous image" data-testid="carousel-prev-btn" className="absolute left-3 top-1/2 -translate-y-1/2" style={arrowStyle}>
              <ChevronLeft size={22} aria-hidden="true" />
            </button>
            <button type="button" onClick={next} aria-label="Next image" data-testid="carousel-next-btn" className="absolute right-3 top-1/2 -translate-y-1/2" style={arrowStyle}>
              <ChevronRight size={22} aria-hidden="true" />
            </button>
          </>
        )}
      </div>
      {images.length > 1 && (
        <div className="flex items-center justify-between mt-3">
          <p className="caption m-0" data-testid="carousel-caption">{current.caption}</p>
          <div className="flex items-center gap-3">
            <div className="flex gap-1.5" aria-hidden="true">
              {images.map((img, i) => (
                <span key={img.file} style={{ width: 8, height: 8, borderRadius: "50%", background: i === index ? "var(--navy-700)" : "var(--border-default)" }} />
              ))}
            </div>
            <span className="caption" data-testid="carousel-counter">{index + 1} / {images.length}</span>
          </div>
        </div>
      )}
      {images.length === 1 && <p className="caption mt-3 m-0">{current.caption}</p>}
    </div>
  );
};
